import { React, useState, useEffect, useLayoutEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import styled from 'styled-components';

import TimeDivisionLine from '../../../Component/MainComponent/TimeDivisionLine.js';
import ClassInfoBox from '../../../Component/MainComponent/ClassInfoBox.js';

import { useTheme } from '../../../Context/ThemeContext';
import { useLanguage } from '../../../Context/LanguageContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import FetchModule from '../../Share/Network/FetchModule.js';

import { ReactComponent as LeftArrowIcon } from '../../../image/LeftArrow.svg';
import MainCalenderBox from '../../../Component/MainComponent/MainCalenderBox.js';

export default function TodayClass(props) {
  const { today, setToday } = props;

  const history = useHistory();
  const { isDark } = useTheme();
  const { t } = useLanguage();
  const theme = isDark ? darkTheme : lightTheme;

  const [scheduleData, setScheduleData] = useState([]);
  const [breakTimeData, setBreakTimeData] = useState([]);
  const [canceledSchedules, setCanceledSchedules] = useState([]);
  const [changedTeachers, setChangedTeachers] = useState([]);
  const [useScheduleData, setUseScheduleData] = useState([]);
  const [reserveData, setReserveData] = useState([]);
  const [reserveRendering, setReserveRendering] = useState(false);
  const [allReserveLock, setAllReserveLock] = useState(false);

  const [calenderHeight, setCalenderHeight] = useState(0);
  const [isClickedDate, setIsClickedDate] = useState(false);

  const [isClickedReserve, setIsClickedReserve] = useState(false);

  const DateButtonRef = useRef();

  // Schedule Data API호출
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('schedule/', 'POST');

        if (responseData.status === 200) setScheduleData(responseData.data);
      }
    )();
  }, [history])

  // BreakTime Data API호출
  useEffect(() => {
    let requestData = {
      classDate: today.clone().format('YYYY-MM-DDT00:00:00')
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('breaktime/', 'POST', requestData);

        if (responseData.status === 200) setBreakTimeData(responseData.data);
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [history, today])

  // 폐강된 수업 데이터 불러오기 //
  useEffect(() => {
    let requestData = {
      startDate: today.clone().format('YYYY-MM-DDT00:00:00'),
      endDate: today.clone().format('YYYY-MM-DDT00:00:00')
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('schedule/canceled', 'POST', requestData);

        if (responseData.status === 200) setCanceledSchedules(responseData.data.canceledSchedules);
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [history, today])

  // 코치가 변경된 수업 데이터 불러오기 //
  useEffect(() => {
    let requestData = {
      startDate: today.clone().format('YYYY-MM-DDT00:00:00'),
      endDate: today.clone().format('YYYY-MM-DDT00:00:00')
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('changed_teacher/', 'POST', requestData);

        if (responseData.status === 200) setChangedTeachers(responseData.data.changedTeachers);
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [history, today])

  // Schedule Data를 사용 가능한 Data로 가공
  useLayoutEffect(() => {
    let tmp = scheduleData.slice();
    let newScheduleData = [];

    for (let i = 0; i < tmp.length; i++) {

      let endPoint = moment(tmp[i].classDate.split('T')[0]);

      if (endPoint.isBefore(today)) endPoint = today;

      while (endPoint.isBefore(moment(tmp[i].endDate))) {

        if (endPoint.diff(today, 'days') >= 30) break;

        if (tmp[i].repeatWeek.includes(getWeekNumber(endPoint.format('YYYY-MM-DD')).toString()) || tmp[i].repeatWeek.includes('0')) {
          if (tmp[i].applyWeek.includes(endPoint.format('ddd')) || tmp[i].applyWeek === 'All') {
            let newData = {
              classId: tmp[i].classId,
              classDate: endPoint.format('YYYY.MM.DD'),
              className: tmp[i].className,
              classTime: tmp[i].classTime,
              color: tmp[i].color,
              endDate: tmp[i].endDate,
              lessonId: tmp[i].lessonId,
              scheduleId: tmp[i].scheduleId,
              teacherName: tmp[i].teacherName,
              profile: tmp[i].profile,
              applyWeek: tmp[i].applyWeek,
              maxBookedPeople: tmp[i].maxBookedPeople,
              deduction: tmp[i].deduction
            }
            newScheduleData.push(newData);
          }
        }
        endPoint = endPoint.clone().add(1, 'day');
      }
    }

    newScheduleData.sort(function (a, b) {
      return a.classDate < b.classDate ? -1 : a.classDate > b.classDate ? 1 : 0;
    })

    let newData = [];

    for (let i = 0; i < newScheduleData.length; i++) {

      if (newScheduleData[i].classDate === today.clone().format('YYYY.MM.DD')) {
        newData.push(newScheduleData[i]);
      }
    }

    // breaktime 데이터 가공
    for (let z = 0; z < breakTimeData.length; z++) {
      if (moment(breakTimeData[z].classDate).isBefore(moment(today.clone().format('YYYY-MM-DDT') + breakTimeData[z].startTime)) && moment(breakTimeData[z].endDate).isAfter(today.clone())) {
        if (breakTimeData[z].repeatWeek.includes(getWeekNumber(today.clone().format('YYYY-MM-DD'))) || breakTimeData[z].repeatWeek === '0') {
          if (breakTimeData[z].applyWeek.includes(today.clone().format('ddd')) || breakTimeData[z].applyWeek === 'All') {

            let breakData = {
              classId: -1,
              lessonId: -1,
              classDate: today.clone().format('YYYY.MM.DD'),
              color: '#ECECEC',
              classTime: breakTimeData[z].startTime + '-' + breakTimeData[z].endTime,
              className: t('main.schedule.breakTime'),
              applyWeek: breakTimeData[z].applyWeek
            }

            newData.push(breakData);
          }
        }
      }
    }

    newData.sort(function (a, b) {
      return a.classTime < b.classTime ? -1 : a.classTime > b.classTime ? 1 : 0;
    })

    // TimeDivisionLine에서 사용할 데이터 가공
    for (let i = 0; i < newData.length; i++) {
      tmp = newData[i].classTime.split('-');
      let splitTmp = tmp[0].split(':');
      let Time = '';

      if (parseInt(splitTmp[0]) > 12) {
        newData[i].startTime = (parseInt(splitTmp[0]) - 12) + ':' + splitTmp[1] + ' PM';
        Time = (parseInt(splitTmp[0]) - 12) + ' PM';
      }
      else if (parseInt(splitTmp[0]) === 12) {
        newData[i].startTime = splitTmp[0] + ':' + splitTmp[1] + ' PM';
        Time = parseInt(splitTmp[0]) + ' PM';
      }
      else {
        newData[i].startTime = splitTmp[0] + ':' + splitTmp[1] + ' AM';
        Time = parseInt(splitTmp[0]) + ' AM';
      }

      tmp = newData[i].classTime.split('-');
      splitTmp = tmp[1].split(':');

      if (parseInt(splitTmp[0]) > 12) {
        newData[i].endTime = (parseInt(splitTmp[0]) - 12) + ':' + splitTmp[1] + ' PM';
      }
      else if (parseInt(splitTmp[0]) === 12) {
        newData[i].endTime = splitTmp[0] + ':' + splitTmp[1] + ' PM';
        Time = parseInt(splitTmp[0]) + ' PM';
      }
      else {
        newData[i].endTime = splitTmp[0] + ':' + splitTmp[1] + ' AM';
      }

      if (i !== 0 && newData[i - 1].startTime.split(':')[0] === newData[i].startTime.split(':')[0]) {
        newData[i] = Object.assign(newData[i], { isNeedNewDivide: false })
        newData[i] = Object.assign(newData[i], { viewTime: Time })
      }
      else {
        newData[i] = Object.assign(newData[i], { isNeedNewDivide: true })
        newData[i] = Object.assign(newData[i], { viewTime: Time })
      }
    }

    let newReserve = [];

    for (let h = 0; h < newData.length; h++) {
      newReserve.push(new Array());
    }

    let newTotalData = [];
    let newDataList = [];

    for (let i = 0; i < newData.length; i++) {
      // 중복검사 //
      let isExist = false;

      for (let j = 0; j < newTotalData.length; j++) {
        let isInnerExist = false;

        for (let z = 0; z < newTotalData[j].length; z++) {
          if (newTotalData[j][z].classDate === newData[i].classDate
            && newTotalData[j][z].classTime === newData[i].classTime
            && newTotalData[j][z].className === newData[i].className) {
            isExist = true;
            isInnerExist = true;
            break;
          }
        }

        if (isInnerExist) break;
      }

      if (!isExist) {
        newDataList.push(newData[i]);
      }
    }

    if (newDataList.length !== 0) newTotalData.push(newDataList);

    if (changedTeachers.length > 0) {
      const teacherMap = new Map();

      for (const teacher of changedTeachers) {
        const key = `${teacher.scheduleId}_${moment(teacher.classDate).format('YYYY.MM.DD')}`;
        teacherMap.set(key, {
          teacherNames: teacher.teacherNames,
          teacherProfile: teacher.teacherProfile
        });
      }

      for (let i = 0; i < newTotalData.length; i++) {
        for (let j = 0; j < newTotalData[i].length; j++) {
          const item = newTotalData[i][j];
          const key = `${item.scheduleId}_${item.classDate}`;
          const teacherData = teacherMap.get(key);

          if (teacherData) {
            const names = teacherData.teacherNames.split(',');
            const profiles = teacherData.teacherProfile ? teacherData.teacherProfile.split(',') : [];

            item.isChangedTeachers = true;
            item.teacherNames = names;
            item.teacherProfile = profiles;
            item.profile = profiles.length > 0 ? profiles[0] : item.profile;
            item.teacherName = names.length > 0
              ? `${names[0]} Coach`
              : ``;
          }
          else {
            item.isChangedTeachers = false;
            item.teacherNames = [];
            item.teacherProfile = [];
          }
        }
      }
    }

    setReserveData(newReserve);
    setUseScheduleData(newData);
  }, [scheduleData, changedTeachers, breakTimeData, today])

  // 날짜 클릭시 달력 생성 //
  useEffect(() => {
    if (isClickedDate) setCalenderHeight(654);
    else setCalenderHeight(0);
  }, [isClickedDate])

  // ReservationData
  useLayoutEffect(() => {
    let schedules = useScheduleData.slice();
    let scheduleIds = [];

    for (let i = 0; i < schedules.length; i++) {
      scheduleIds.push(schedules[i].scheduleId === undefined ? 0 : schedules[i].scheduleId);
    }

    // 조회할 데이터가 있을경우 //
    if (scheduleIds.length > 0) {
      let requestData = {
        scheduleIds: scheduleIds,
        classDate: schedules[0].classDate.replaceAll('.', '-') + 'T00:00:00'
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('reserve/status/check', 'POST', requestData);

          if (responseData.status === 200) {
            setAllReserveLock(!responseData.data.isAllLock);
            setReserveData(responseData.data.status);
          }
        }
      )();
    }
    // 조회할 데이터가 없을경우 //
    else setAllReserveLock(false);
  }, [useScheduleData, reserveRendering])

  // 몇주차인지 계산하기 //
  function getWeekNumber(date) {
    const standard = new Date(date);

    const currentDate = standard.getDate();
    const startOfMonth = new Date(standard.setDate(1));
    const weekDay = startOfMonth.getDay();

    return parseInt(((weekDay - 1) + currentDate) / 7) + 1;
  }

  // 다음 날짜 버튼 클릭시 //
  function onClickNextDate() {
    setToday(today.clone().add(1, 'days'));
  }

  // 이전 날짜 버튼 클릭시 //
  function onClickPrevDate() {
    setToday(today.clone().subtract(1, 'days'));
  }

  // 날짜 클릭시 달력 띄우기 //
  function onClickMainDate() {
    setIsClickedDate(!isClickedDate);
  }

  return (
    <TopLevelWrapper $isDark={isDark}>
      <TitleWrapper>
        <TitleTopLine>
          <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} cursor='default'>{t('main.schedule.title')}</Text>
          <DateMoveWrapper>
            <DateMoveButton onClick={onClickPrevDate} />
            <DateText ref={DateButtonRef} onClick={onClickMainDate}>{today.clone().format(t('main.schedule.dateFormat'))}</DateText>
            <DateMoveButton onClick={onClickNextDate} $isRight />
          </DateMoveWrapper>
        </TitleTopLine>
        <ExplanationWrapper>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{t('main.schedule.desc').replace('{date}', today.clone().format(t('main.schedule.dateFormat')))}</Text>
          <Text fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.primary} cursor='pointer' onClick={() => window.open('/class', '_blank')}>{t('main.schedule.detail')}</Text>
        </ExplanationWrapper>
        <ViewWrapper>
          {
            useScheduleData.length === 0 ?
              <EmptyBoxWrapper>
                <EmptyBox>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.gray} cursor='default'>{t('main.schedule.noClass')}</Text>
                </EmptyBox>
              </EmptyBoxWrapper>
              :
              <ViewBox>
                <TimeDivisionLineWrapper>
                  {
                    useScheduleData.map((data, index) => (
                      <TimeDivisionLine key={index} scheduleData={data} isMain={true} />
                    ))
                  }
                </TimeDivisionLineWrapper>
                <ClassInfoBoxWrapper>
                  {
                    useScheduleData.map((data, index) => (
                      <ClassInfoBox
                        key={index}
                        data={data}
                        canceledSchedules={canceledSchedules}
                        reserveData={reserveData}
                        reserveRendering={reserveRendering}
                        setReserveRendering={setReserveRendering} />
                    ))
                  }
                </ClassInfoBoxWrapper>
              </ViewBox>
          }
          <CalenderBox height={calenderHeight}>
            <MainCalenderBox value={today} setValue={setToday} setIsClicked={setIsClickedDate} DateButtonRef={DateButtonRef} />
          </CalenderBox>
        </ViewWrapper>
      </TitleWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 612px;
  height: 767px;

  border-radius: 30px;
  background-color: ${props => props.theme.subBackground};
  box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(240, 232, 227, 0.5)'};
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const TitleTopLine = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const DateMoveWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const DateMoveButton = styled(LeftArrowIcon)`
  width: 8px;
  height: 13px;

  transform: ${props => props.$isRight ? 'rotate(180deg)' : 'none'};

  & path {
    fill: ${props => props.theme.subText};
  }

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const ExplanationWrapper = styled.div`
  display: flex;
  flex-direction: row;

  gap: 314px;
  margin-top: 4px;
  margin-bottom: 24px;
`;

const ViewBox = styled.div`
  display: flex;
  flex-direction: row;

  width: 556px;
  height: 630px;

  padding-top: 24px;

  border-top: 2px solid ${props => props.theme.line};

  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 4px;
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${props => props.theme.scrollBar};
    border-radius: 2px;
  }

  &::-webkit-scrollbar-track {
    background: linear-gradient(
      to right,
      transparent 1.5px,
      ${props => props.theme.line} 1.5px,
      ${props => props.theme.line} 2.5px,
      transparent 2.5px
    );
    border-radius: 2px;
  }
`;

const ViewWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const CalenderBox = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 556px;
  height: ${props => props.height}px;

  border-top: 2px solid ${props => props.theme.line};
  background-color: ${props => props.theme.subBackground};

  overflow: hidden;

  transition: all 0.3s ease-in-out;
`;

const EmptyBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 556px;
  height: 630px;

  padding-top: 24px;

  border-top: 2px solid ${props => props.theme.line};
`;

const EmptyBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;
`;

const TimeDivisionLineWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const ClassInfoBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;

const DateText = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    color: ${props => props.theme.primary};
  }
`;
